export default "__VITE_ASSET__2fe1c776__"